import { Site } from '@envato/foundation-types'
import * as normalizeUrl from 'normalize-url'
import { match } from 'react-router-dom'

import ga from '../../utils/ga'
import { parseLocation } from '../../utils/urlHelper'
import { hasFeature } from '../features'
import { formatSearchLocationParams } from './format'
import { ICommonLocation, ILocationParams, IQuery } from './types'

interface IGetSearchLocationParamsProps {
  location: ICommonLocation
  routeMatch: match<IQuery>
  currentSite: Site
  experiments?: any
}

export const stringUrlsEqual = (a: string, b: string) => {
  if (a === b) {
    return true
  }

  return (
    normalizeUrl(a, { removeTrailingSlash: false }) ===
    normalizeUrl(b, { removeTrailingSlash: false })
  )
}

export const redirectToItemPage = (itemId: string) => {
  if (typeof window !== 'undefined') {
    ga('set', 'searchByItemId', window.location.href)
  }

  return `/item/by-id/${itemId}`
}

export const getLocationParams = (
  location: ICommonLocation,
  routeMatch: match<IQuery>
): IQuery => ({
  ...location.query,
  ...routeMatch.params
})

export const getSearchLocationParams = ({
  location,
  routeMatch,
  currentSite,
  experiments
}: IGetSearchLocationParamsProps): ILocationParams => {
  if (hasFeature('routes:new', currentSite, location, experiments)) {
    return formatSearchLocationParams(getLocationParams(location, routeMatch))
  }

  return parseLocation({
    pathname: location.pathname || '/',
    query: location.query
  })
}

export const getSearchTypeFromLocationParams = (
  locationParams: ILocationParams
) => {
  if (locationParams.category) {
    return 'category'
  } else if (locationParams.tags) {
    return 'tags'
  } else {
    return 'search'
  }
}

export const convertToCommonLocation = (
  location: Partial<ICommonLocation>
): ICommonLocation => ({
  pathname: location.pathname || '/',
  search: location.search || '',
  query: location.query || {},
  hash: location.hash || ''
})
